import {ProductData} from "@/types/product";
import Alert from "@/components/UiElements/Alert";
import ImageComponent from "@/components/UiElements/ImageComponent";
import React from "react";
import store from "@/store";
import changeProductProfileState from "@/services/ProductService/changeProductProfileState";
import updateProductInLocal from "@/services/ProductService/updateProductInLocal";

const convertSingleToBundle = async (product: ProductData): Promise<boolean> => {
    if (product.product_profile_id) {
        const userResponse = await new Promise<boolean>((resolve) => {
            Alert.showAlert({
                title: "Convert to Bundle",
                message: (
                    <div className={"flex flex-col items-center justify-center "}>
                        <div className={"border border-gray-300 p-sm rounded-md my-md"}>
                            <ImageComponent
                                src={product?.["2d_image_url"]}
                                className={"!w-[100px] !h-[100px]"}
                            />
                        </div>
                        This product (SKU:{product.sku}) currently has a profile. Converting it to a bundle will delete the profile. Do you want to proceed?
                    </div>
                ),
                isCancelable: true,
                button: "Yes, Convert",
                callBack: (ok) => resolve(ok), // Resolve the promise with the user's response
            });
        });

        if (!userResponse) return false; // If the user cancels, exit the function

        // Proceed with the conversion if the user confirms
        return await convert(product);
    } else {
        return await convert(product);
    }
};

const convert = async (product: ProductData): Promise<boolean> => {
    try {

        const response = await changeProductProfileState(product.product_id, false);
        await updateProductInLocal({
            ...product,
            is_bundle: true,
            product_profile_id: "",
            is_product_profile_active: false,
        });
        store.loadingPage = null;
        return !!response;
    } catch (error) {
        console.error("Error during conversion:", error);
        return false;
    }
};

export default convertSingleToBundle;
